<template>
  <div>
    <b-field label="Adresse Postale" class=" mt-10">
      <gmap-autocomplete @place_changed="placeChange" selectFirstOnEnter
        class="input" type="search" placeholder="adresse prospect"
        v-model="libelleAdresse"
        :options="getBounds()"/>
    </b-field>
    <div>
      <b-field>
        <b-input placeholder="intitule 1"
                 v-model="adresse.intitule1"></b-input>
      </b-field>
      <b-field>
        <b-input placeholder="intitule 2"
                 v-model="adresse.intitule2"></b-input>
      </b-field>
      <b-field>
        <b-input placeholder="intitule 3"
                 v-model="adresse.intitule3"></b-input>
      </b-field>
    </div>
    <b-field label="Adresse" class="mt-10">
      <b-input placeholder="adresse 1"
                v-model="adresse.adresse1"></b-input>
    </b-field>
    <b-field>
      <b-input placeholder="adresse 2"
                v-model="adresse.adresse2"></b-input>
    </b-field>
    <b-field>
      <b-input placeholder="adresse 3"
                v-model="adresse.adresse3"></b-input>
    </b-field>
    <div class="columns mt-10">
      <div class="column is-4">
        <b-field label="Code postal">
          <b-input placeholder="codePostal"
                    v-model="adresse.codePostal"></b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field label="Ville">
          <b-input placeholder="ville"
                    v-model="adresse.ville"></b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field label="Pays">
          <b-input placeholder="pays"
                    v-model="adresse.pays"></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import genererAdresse from '@/services/general/genererAdresse';
import gestionErreur from '@/services/general/gestionErreur';
import getGmapAdressComponentMapping from '@/services/general/gmapAdressComponentMapping';

export default {
  props: {
    adresse: {
      type: Object,
      required: true,
      default: genererAdresse(),
    },
  },
  data() {
    return {
      libelleAdresse: null,
      gmapAddressComponentMapping: getGmapAdressComponentMapping(),
    };
  },
  methods: {
    placeChange(place) {
      if (!place.geometry) {
        let messErreur = 'Pas de données géographique pour l\'adresse';
        if (place.name) messErreur = messErreur + ': ' + place.name;
        gestionErreur(messErreur);
        return;
      }
      Object.keys(this.adresse).forEach(key => {
        this.adresse[key] = '';
      });
      this.adresse.latitude = place.geometry.location.lat();
      this.adresse.longitude = place.geometry.location.lng();
      if (place.types
        && place.types.length > 0
        && place.types[place.types.length - 1] === 'establishment'
        && place.name) {
        this.adresse.intitule1 = place.name;
      }
      place.address_components.forEach(element => {
        element.types.forEach(type => {
          if (Object.prototype.hasOwnProperty.call(this.gmapAddressComponentMapping, type)) {
            const mapping = this.gmapAddressComponentMapping[type];
            this.adresse[mapping.field] += element.long_name;
            if (mapping.separator) {
              this.adresse[mapping.field] += mapping.separator;
            }
          }
        });
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/general/adresse.vue